import { IEBlockMaterial } from '../../models/eBlockMaterial.model';
import { AppAction, PageFilter } from '../app';
import {
  EBlockMaterialCreateOrUpdatePayload,
  EBlockMaterialListFilter,
} from './eBlockMaterial.type';

export const FETCH_EBLOCK_MATERIAL = 'FETCH_EBLOCK_MATERIAL';
export const FETCH_EBLOCK_MATERIAL_LIST = 'FETCH_EBLOCK_MATERIAL_LIST';
export const CREATE_EBLOCK_MATERIAL = 'CREATE_EBLOCK_MATERIAL';
export const UPDATE_EBLOCK_MATERIAL = 'UPDATE_EBLOCK_MATERIAL';
export const CLEAR_EBLOCK_MATERIAL = 'CLEAR_EBLOCK_MATERIAL';

export const fetchEBlockMaterial = (id: IEBlockMaterial['id']): AppAction => ({
  type: FETCH_EBLOCK_MATERIAL,
  payload: id,
});

export const fetchEBlockMaterialList = (
  filters: EBlockMaterialListFilter,
  paging: PageFilter,
): AppAction => {
  return {
    type: FETCH_EBLOCK_MATERIAL_LIST,
    payload: {
      filters,
      paging,
    },
  };
};

export const createEBlockMaterial = (
  payload: EBlockMaterialCreateOrUpdatePayload,
): AppAction => ({
  type: CREATE_EBLOCK_MATERIAL,
  payload,
});

export const updateEBlockMaterial = (
  payload: EBlockMaterialCreateOrUpdatePayload,
): AppAction => ({
  type: UPDATE_EBLOCK_MATERIAL,
  payload,
});

export const clearEBlockMaterial = () => ({
  type: CLEAR_EBLOCK_MATERIAL,
});
